<template>
  <div class="container container--vertical">
    <h1>Dashboard</h1>
    <div class="dashboard-grid">
      <current-study />

      <card title="Students" icon="graduation-cap">
        <span class="h2">{{ userCount }}</span>
      </card>

      <card title="Studies" icon="book-open">
        <span class="h2">{{ studyCount }}</span>
      </card>
    </div>
  </div>
</template>

<script>
import Card from '@/components/global/Card';
import CurrentStudy from '@/components/admin/dashboard/CurrentStudy';
import maddyApi from '@/services/maddyApi';

export default {
  name: 'admin-dashboard',
  components: { Card, CurrentStudy },
  data() {
    return {
      userCount: 0,
      studyCount: 0,
    };
  },
  mounted() {
    this.fetchUserCount();
    this.fetchStudyCount();
  },
  methods: {
    async fetchUserCount() {
      const response = await maddyApi.get('/users?take=0');

      if (response.status === 200) {
        this.userCount = response.data._metadata.count;
      }
    },
    async fetchStudyCount() {
      const response = await maddyApi.get('/studies?take=0');
      if (response.status === 200) {
        this.studyCount = response.data._metadata.count;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dashboard-grid {
  width: 100%;
  display: grid;
  gap: 24px;
  grid-template-columns: repeat(3, 1fr);
}
</style>
